<div class="container">

    <div class="row" style="margin: 0 30px;">
        <div class="col">
            <div class="row align-items-center">
                <div class="col">
                    <nav style="--bs-breadcrumb-divider: url(&#34;data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='8' height='8'%3E%3Cpath d='M2.5 0L1 1.5 3.5 4 1 6.5 2.5 8l4-4-4-4z' fill='currentColor'/%3E%3C/svg%3E&#34;);" aria-label="breadcrumb">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item"><a routerLink="/ad-accounts">Ad Accounts</a></li>
                            <li class="breadcrumb-item"><a routerLink="/ad-accounts/{{ accountId }}">{{ accountId | titlecase }}</a></li>
                            <li class="breadcrumb-item active" aria-current="page">Performance Insights Dashboard</li>
                        </ol>
                    </nav>
                </div>
                <div class="col-auto">
                    <div class="row align-items-center">
                        <div class="col">
                        </div>
                        <div class="col-auto">
                            <div class="input-group">
                                <div class="input-group-text" style="font-weight: bold;">Ads</div>                                                        
                                <div class="input-group-text"><a routerLink="/ad-accounts/performance-insights/{{ accountId }}/creatives">Creatives</a></div>                                                        
                                <div class="input-group-text" style="color: #bebebe;">Products</div>                                                        
                            </div>                        
                        </div>
                    </div>
                </div>
            </div>            

            <div style="margin-top: 30px;">
                
                <div style="text-align: center; margin: 20px 0;">
                    <span class="text-primary" (click)="changeView('adsPerDay')" style="cursor: pointer;">Daily Performance</span>
                    <span style="margin-left: 15px; margin-right: 15px;">|</span>
                    <span class="text-primary" (click)="changeView('adsCreativeTest')" style="cursor: pointer;">Creative Test</span>
                    <span style="margin-left: 15px; margin-right: 15px;">|</span>
                    <span class="text-primary" (click)="changeView('ads')" style="cursor: pointer;">All Ads</span>
                </div>

                <!-- 
                All Ads View
                -->
                <div *ngIf="views.ads.show">                    
                    <div class="row align-items-center" style="margin-bottom: 10px;">
                        <div class="col">
                            <h3>{{ views.ads.title }}</h3>
                            <div class="small">{{ views.ads.description }}</div>
                        </div>
                        <div class="col-auto">
                            <div class="input-group" style="height: 38px;">
                                <span class="input-group-text" style="font-size: 0.85em;">Product</span>                              
                                <input
                                    class="form-control"
                                    [placeholder]="views.ads.filterProductCode !== '' ? views.ads.filterProductCode : 'Code'"
                                    [value]="views.ads.filterProductCode"
                                    #adsFilterProductCode
                                    (keydown.enter)="changeFilter('ads', 'product_code', adsFilterProductCode.value)"
                                    style="width: 80px; font-size: 0.85em;"
                                />
                            </div>
                        </div>
                        <div class="col-auto">
                            <div class="input-group">
                                <input
                                    class="form-control"
                                    [placeholder]="views.ads.dateStart"
                                    name="dp"
                                    [(ngModel)]="views.ads.dateStart"
                                    (ngModelChange)="changeDate('ads', 'start', $event)"
                                    ngbDatepicker
                                    #datePickerAdsDateStart="ngbDatepicker"
                                    style="width: 110px; font-size: 0.85em;"
                                />
                                <button class="btn btn-outline-secondary bi bi-calendar3" (click)="datePickerAdsDateStart.toggle()" type="button"></button>
                            </div>
                        </div>
                        <div class="col-auto">
                            <div class="input-group">
                                <input
                                    class="form-control"
                                    [placeholder]="views.ads.dateEnd"
                                    name="dp"
                                    [(ngModel)]="views.ads.dateEnd"
                                    (ngModelChange)="changeDate('ads', 'end', $event)"
                                    ngbDatepicker
                                    #datePickerAdsDateEnd="ngbDatepicker"
                                    style="width: 110px; font-size: 0.85em;"
                                />
                                <button class="btn btn-outline-secondary bi bi-calendar3" (click)="datePickerAdsDateEnd.toggle()" type="button"></button>
                            </div>
                        </div>
                    </div>                    
                    <table style="margin-bottom: 30px;" class="table table-sm table-striped table-bordered tableInsights">
                        <thead>
                            <tr>
                                <th scope="col" style="width: 60px;"></th>
                                <th scope="col"><span class="text-primary" (click)="changeOrderBy('ads', 'name')" style="cursor: pointer;">Name</span></th>
                                <th scope="col">Ad Set</th>
                                <th scope="col">Campaign</th>
                                <th scope="col"><span class="text-primary" (click)="changeOrderBy('ads', 'amount_spent')" style="cursor: pointer;">Spend</span></th>
                                <th scope="col"><span class="text-primary" (click)="changeOrderBy('ads', 'purchases')" style="cursor: pointer;">Purchases</span></th>
                                <th scope="col"><span class="text-primary" (click)="changeOrderBy('ads', 'revenue')" style="cursor: pointer;">Revenue</span></th>
                                <th scope="col"><span class="text-primary" (click)="changeOrderBy('ads', 'roas')" style="cursor: pointer;">ROAS</span></th>
                            </tr>
                        </thead>
                        <tbody>
                            <ng-container *ngIf="views.ads.loadingAds">
                                <tr>
                                    <td colspan="8" style="text-align: center;"><span class="spinner-border text-dark" role="status" aria-hidden="true" style="vertical-align: middle; margin: 10px 0;"></span></td>
                                </tr>
                            </ng-container>
                            <ng-container *ngFor="let ad of views.ads.ads">
                                <tr>
                                    <td><a href="https://adsmanager.facebook.com/adsmanager/manage/ads/edit/standalone?act={{ accountMetaId }}&selected_ad_ids={{ ad.id }}" target="_blank"><img [src]="ad.creative_image_url" style="width: 50px; height: 50px;"></a></td>
                                    <td><span [ngbTooltip]="ad.name + ' [#' + ad.id + ']'">{{ ad.name | shorten: 40 }}</span></td>
                                    <td><span [ngbTooltip]="ad.adset_name">{{ ad.adset_name | shorten: 20 }}</span></td>
                                    <td><span [ngbTooltip]="ad.campaign_name">{{ ad.campaign_name | shorten: 20 }}</span></td>
                                    <td style="text-align: right;">{{ ad.metrics?.amount_spent ? (ad.metrics?.amount_spent | currency) : '-' }}</td>
                                    <td style="text-align: right;">{{ ad.metrics?.purchases ? (ad.metrics?.purchases | number) : '-' }}</td>
                                    <td style="text-align: right;">{{ ad.metrics?.revenue ? (ad.metrics?.revenue | currency) : '-' }}</td>
                                    <td style="text-align: right;">{{ ad.metrics?.roas ? (ad.metrics?.roas | number:'1.2-2') : '-' }}</td>
                                </tr>
                            </ng-container>
                        </tbody>
                    </table>
                </div>


                <!-- 
                Ads Creative Test View
                -->
                <div *ngIf="views.adsCreativeTest.show">                    
                    <div class="row align-items-center">
                        <div class="col">
                            <h3>{{ views.adsCreativeTest.title }}</h3>
                            <div class="small">{{ views.adsCreativeTest.description }}</div>
                        </div>
                        <div class="col-auto">
                            <div class="input-group" style="height: 38px;">
                                <span class="input-group-text" style="font-size: 0.85em;">Test ID #1</span>                              
                                <input
                                    class="form-control"
                                    [(ngModel)]="views.adsCreativeTest.filterAdNameContains"
                                    (keydown.enter)="changeFilter('adsCreativeTest', 'ad_name_contains', views.adsCreativeTest.filterAdNameContains)"
                                    style="width: 120px; font-size: 0.85em;"
                                />
                            </div>
                        </div>                        
                        <div class="col-auto">
                            <div class="input-group" style="height: 38px;">
                                <span class="input-group-text" style="font-size: 0.85em;">Test ID #2</span>                              
                                <input
                                    class="form-control"
                                    [(ngModel)]="views.adsCreativeTest.filterAdNameContains2"
                                    (keydown.enter)="changeFilter('adsCreativeTest', 'ad_name_contains_2', views.adsCreativeTest.filterAdNameContains2)"
                                    placeholder="IMGTSTXXX"
                                    style="width: 120px; font-size: 0.85em;"
                                />
                            </div>
                        </div>                        
                        <div class="col-auto">
                            <div class="input-group">
                                <input
                                    class="form-control"
                                    [placeholder]="views.adsCreativeTest.dateStart"
                                    name="dp"
                                    [(ngModel)]="views.adsCreativeTest.dateStart"
                                    (ngModelChange)="changeDate('ads', 'start', $event)"
                                    ngbDatepicker
                                    #datePickerAdsDateStart="ngbDatepicker"
                                    style="width: 110px; font-size: 0.85em;"
                                />
                                <button class="btn btn-outline-secondary bi bi-calendar3" (click)="datePickerAdsDateStart.toggle()" type="button"></button>
                            </div>
                        </div>
                        <div class="col-auto">
                            <div class="input-group">
                                <input
                                    class="form-control"
                                    [placeholder]="views.ads.dateEnd"
                                    name="dp"
                                    [(ngModel)]="views.ads.dateEnd"
                                    (ngModelChange)="changeDate('ads', 'end', $event)"
                                    ngbDatepicker
                                    #datePickerAdsDateEnd="ngbDatepicker"
                                    style="width: 110px; font-size: 0.85em;"
                                />
                                <button class="btn btn-outline-secondary bi bi-calendar3" (click)="datePickerAdsDateEnd.toggle()" type="button"></button>
                            </div>
                        </div>
                    </div>
                    <div *ngIf="!views.adsCreativeTest.loadingAds" class="row align-items-center" style="margin-bottom: 10px;">
                        <div class="col">                            
                        </div>                
                        <div class="col-auto" style="font-size: 0.80em;">
                            Order by:
                            <span class="text-primary" (click)="changeOrderBy('adsCreativeTest', 'name')" style="cursor: pointer; margin-left: 10px;">Name</span>
                            <span class="text-primary" (click)="changeOrderBy('adsCreativeTest', 'amount_spent')" style="cursor: pointer; margin-left: 10px;">Spend</span>
                            <span class="text-primary" (click)="changeOrderBy('adsCreativeTest', 'purchases')" style="cursor: pointer; margin-left: 10px;">Purchases</span>
                            <span class="text-primary" (click)="changeOrderBy('adsCreativeTest', 'revenue')" style="cursor: pointer; margin-left: 10px;">Revenue</span>
                            <span class="text-primary" (click)="changeOrderBy('adsCreativeTest', 'roas')" style="cursor: pointer; margin-left: 10px;">ROAS</span>
                        </div>        
                    </div>

                    <ng-container *ngIf="views.adsCreativeTest.loadingAds">
                        <div style="text-align: center;"><span class="spinner-border text-dark" role="status" aria-hidden="true" style="vertical-align: middle; margin: 10px 0;"></span></div>
                    </ng-container>

                    <div class="row row-cols-auto justify-content-center">
                        <div *ngFor="let ad of views.adsCreativeTest.ads" class="col">
                          <div class="card" style="width: 190px; margin-bottom: 20px;">
                            <a href="https://adsmanager.facebook.com/adsmanager/manage/ads/edit/standalone?act={{ accountMetaId }}&selected_ad_ids={{ ad.id }}" target="_blank"><img [src]="ad.creative_image_url" style="width: 190px; height: 190px;" class="card-img-top"></a>
                            <div class="card-body">
                              <div style="font-size: 0.80em; font-weight: bold;"><span [ngbTooltip]="ad.name + ' [#' + ad.id + ']'">{{ ad.name | shorten: 22 }}</span></div>
                              <div class="row align-items-center">
                                <div class="col-auto" style="font-size: 0.75em;">ROAS</div>
                                <div class="col" style="font-size: 0.8em; text-align: right;"><span class="badge bg-dark">{{ ad.metrics?.roas | number:'1.2-2' }}</span></div>
                              </div>                              
                              <div class="row align-items-center">
                                <div class="col-auto" style="font-size: 0.75em;">Spend</div>
                                <div class="col" style="font-size: 0.8em; text-align: right;"><span class="badge bg-dark">{{ ad.metrics?.amount_spent ? (ad.metrics?.amount_spent | currency) : '-' }}</span></div>
                              </div>                              
                              <div class="row align-items-center">
                                <div class="col-auto" style="font-size: 0.75em;">Purchases</div>
                                <div class="col" style="font-size: 0.8em; text-align: right;"><span class="badge bg-dark">{{ ad.metrics?.purchases ? (ad.metrics?.purchases | number) : '-' }}</span></div>
                              </div>                              
                              <div class="row align-items-center">
                                <div class="col-auto" style="font-size: 0.75em;">Revenue</div>
                                <div class="col" style="font-size: 0.8em; text-align: right;"><span class="badge bg-dark">{{ ad.metrics?.revenue ? (ad.metrics?.revenue | currency) : '-' }}</span></div>
                              </div>                                                         
                            </div>
                          </div>
                        </div>
                    </div>        
                    <!-- <table  style="margin-bottom: 30px;" class="table table-sm table-striped table-bordered tableInsights">
                        <thead>
                            <tr>
                                <th scope="col" style="width: 60px;"></th>
                                <th scope="col"><span class="text-primary" (click)="changeOrderBy('adsCreativeTest', 'name')" style="cursor: pointer;">Name</span></th>
                                <th scope="col">Ad Set</th>
                                <th scope="col">Campaign</th>
                                <th scope="col"><span class="text-primary" (click)="changeOrderBy('adsCreativeTest', 'amount_spent')" style="cursor: pointer;">Spend</span></th>
                                <th scope="col"><span class="text-primary" (click)="changeOrderBy('adsCreativeTest', 'purchases')" style="cursor: pointer;">Purchases</span></th>
                                <th scope="col"><span class="text-primary" (click)="changeOrderBy('adsCreativeTest', 'revenue')" style="cursor: pointer;">Revenue</span></th>
                                <th scope="col"><span class="text-primary" (click)="changeOrderBy('adsCreativeTest', 'roas')" style="cursor: pointer;">ROAS</span></th>
                            </tr>
                        </thead>
                        <tbody>
                            <ng-container *ngIf="views.adsCreativeTest.loadingAds">
                                <tr>
                                    <td colspan="8" style="text-align: center;"><span class="spinner-border text-dark" role="status" aria-hidden="true" style="vertical-align: middle; margin: 10px 0;"></span></td>
                                </tr>
                            </ng-container>
                            <ng-container *ngFor="let ad of views.adsCreativeTest.ads">
                                <tr>
                                    <td><a href="https://adsmanager.facebook.com/adsmanager/manage/ads/edit/standalone?act={{ accountMetaId }}&selected_ad_ids={{ ad.id }}" target="_blank"><img [src]="ad.creative_image_url" style="width: 50px; height: 50px;"></a></td>
                                    <td><span [ngbTooltip]="ad.name + ' [#' + ad.id + ']'">{{ ad.name | shorten: 40 }}</span></td>
                                    <td><span [ngbTooltip]="ad.adset_name">{{ ad.adset_name | shorten: 20 }}</span></td>
                                    <td><span [ngbTooltip]="ad.campaign_name">{{ ad.campaign_name | shorten: 20 }}</span></td>
                                    <td style="text-align: right;">{{ ad.metrics?.amount_spent ? (ad.metrics?.amount_spent | currency) : '-' }}</td>
                                    <td style="text-align: right;">{{ ad.metrics?.purchases ? (ad.metrics?.purchases | number) : '-' }}</td>
                                    <td style="text-align: right;">{{ ad.metrics?.revenue ? (ad.metrics?.revenue | currency) : '-' }}</td>
                                    <td style="text-align: right;">{{ ad.metrics?.roas ? (ad.metrics?.roas | number:'1.2-2') : '-' }}</td>
                                </tr>
                            </ng-container>
                        </tbody>
                    </table> -->
                </div>


                <!-- 
                Ads Per Day View
                -->
                <div *ngIf="views.adsPerDay.show">
                    <div class="row align-items-center" style="margin-bottom: 10px;">
                        <div class="col">
                            <h3>{{ views.adsPerDay.title }}</h3>
                            <div class="small">{{ views.adsPerDay.description }}</div>
                        </div>
                        <div class="col-auto">
                            <div class="input-group">
                                <input
                                    class="form-control"
                                    [placeholder]="views.adsPerDay.dateStart"
                                    name="dp"
                                    [(ngModel)]="views.adsPerDay.dateStart"
                                    (ngModelChange)="changeDate('adsPerDay', 'start', $event)"
                                    ngbDatepicker
                                    #datePickerAdsPerDayDateStart="ngbDatepicker"
                                    style="width: 110px; font-size: 0.85em;"
                                />
                                <button class="btn btn-outline-secondary bi bi-calendar3" (click)="datePickerAdsPerDayDateStart.toggle()" type="button"></button>
                            </div>
                        </div>
                        <div class="col-auto">
                            <div class="input-group">
                                <input
                                    class="form-control"
                                    [placeholder]="views.adsPerDay.dateEnd"
                                    name="dp"
                                    [(ngModel)]="views.adsPerDay.dateEnd"
                                    (ngModelChange)="changeDate('adsPerDay', 'end', $event)"
                                    ngbDatepicker
                                    #datePickerAdsPerDayDateEnd="ngbDatepicker"
                                    style="width: 110px; font-size: 0.85em;"
                                />
                                <button class="btn btn-outline-secondary bi bi-calendar3" (click)="datePickerAdsPerDayDateEnd.toggle()" type="button"></button>
                            </div>
                        </div>
                    </div>
                    <table style="margin-bottom: 30px;" class="table table-sm table-striped table-bordered tableInsights">
                        <thead>
                            <tr>
                                <th scope="col"><span class="text-primary" (click)="changeOrderBy('adsPerDay', 'date')" style="cursor: pointer;">Date</span></th>
                                <th scope="col"><span class="text-primary" (click)="changeOrderBy('adsPerDay', 'amount_spent')" style="cursor: pointer;">Spend</span></th>
                                <th scope="col"><span class="text-primary" (click)="changeOrderBy('adsPerDay', 'purchases')" style="cursor: pointer;">Purchases</span></th>
                                <th scope="col"><span class="text-primary" (click)="changeOrderBy('adsPerDay', 'revenue')" style="cursor: pointer;">Revenue</span></th>
                                <th scope="col"><span class="text-primary" (click)="changeOrderBy('adsPerDay', 'roas')" style="cursor: pointer;">ROAS</span></th>
                            </tr>
                        </thead>
                        <tbody>
                            <ng-container *ngIf="views.adsPerDay.loadingAdsPerDay">
                                <tr>
                                    <td colspan="5" style="text-align: center;"><span class="spinner-border text-dark" role="status" aria-hidden="true" style="vertical-align: middle; margin: 10px 0;"></span></td>
                                </tr>
                            </ng-container>
                            <ng-container *ngFor="let day of views.adsPerDay.adsPerDay">
                                <tr>
                                    <td><span [ngbTooltip]="day.date">{{ day.date }}</span></td>
                                    <td style="text-align: right;">{{ day.metrics.amount_spent ? (day.metrics.amount_spent | currency) : '-' }}</td>
                                    <td style="text-align: right;">{{ day.metrics.purchases ? (day.metrics.purchases | number) : '-' }}</td>
                                    <td style="text-align: right;">{{ day.metrics.revenue ? (day.metrics.revenue | currency) : '-' }}</td>
                                    <td style="text-align: right;">{{ day.metrics.roas ? (day.metrics.roas | number:'1.2-2') : '-' }}</td>
                                </tr>
                            </ng-container>
                        </tbody>
                    </table>
                </div>

            </div>                         

        </div>    
    </div>
</div>